import React, { useEffect, useState } from "react";
import mint_pop from "../Assets/mint_pop.jpg"

import Modal from "react-bootstrap/Modal";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import {
  Mint_Contract_Abi,
  Mint_Contract_Address,
} from "../../utilies/constant";
import Web3 from "web3";
import toast from "react-hot-toast";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";

export default function MintModel(props) {
  const [quantity, setQuantity] = useState(1);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [getBNB_value, setgetBNB_value] = useState("");
  const [mintPrice, setMintPrice] = useState(0);
  const [Price, setPrice] = useState(0);

  const [totalsupply, settotalsupply] = useState(0);

  const webSupply = new Web3("https://brockrpc.io");
  const [spinner, setspinner] = useState(false);

  const increaseQuantity = () => {
    setQuantity((prev) => (prev < 25 ? prev + 1 : prev));
  };

  const decreaseQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handleChange_value = (e) => {
    setgetBNB_value(e.target.value);
  };

  const contractData = async () => {
    try {
      const contract = new webSupply.eth.Contract(
        Mint_Contract_Abi,
        Mint_Contract_Address
      );
      let tsupply =await contract.methods.totalSupply().call()
      let currentPrice= await contract.methods.checkPrice().call()
      setPrice(webSupply.utils.fromWei(currentPrice.toString()));
      settotalsupply(tsupply)
      const [mintValue] = await Promise.all([
        contract.methods.getprice(quantity).call(),
      ]);
      setMintPrice(webSupply.utils.fromWei(mintValue.toString()));
    } catch (error) {
      console.error("Error fetching contract data:", error);
    }
  };

  const mintNFT = async () => {
    try {
      if (!address) {
        toast.error("Please Connect Metamask First!");
        return;
      }
      setspinner(true);
      console.log("here");
      
      const { request: purchaseRequest } = await prepareWriteContract({
        address: Mint_Contract_Address,
        abi: Mint_Contract_Abi,
        functionName: "mint",
        args: [quantity],
        value: webSupply.utils.toWei(mintPrice.toString()),
        account: address,
      });
      console.log("here2");
      const { hash: purchaseHash } = await writeContract(purchaseRequest);
      await waitForTransaction({ hash: purchaseHash });
      setTimeout(async () => {
        toast.success("NFT mint Successful");
        setspinner(false);
      }, 3000);
    } catch (error) {
      console.error("Error in staking_Amount:", error);
      setspinner(false);
    }
  };

  useEffect(() => {
    contractData();
  }, [quantity]);
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="modal_overlay2">
            <div className="modal_header">
              <h2>Collect YOUR NFT before end</h2>
              <button data-bs-dismiss="modal" aria-label="Close">
                <span className="clossbtn_bg">
                  <i className="fa-solid fa-xmark" onClick={props.onHide} />
                </span>
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="mint_img">
              <img src={mint_pop} className="w-100" alt="" />
              {/* <video className="mint_img" src="assets/images/bitrockwallet nft genesis rare nft card.gif.mp4" autoPlay muted loop></video> */}
              </div>
              <div className="mint_count_list">
                <ul>
                  <li>
                    <h5>Remaining</h5>
                    <h5>
                      {totalsupply}/<span>5555</span>
                    </h5>
                  </li>
                  <li>
                    <h5>Price</h5>
                    <h5>{Price} BROCK</h5>
                  </li>
                  <li>
                    <h5>Quantity</h5>
                    {/* <div className="mint_quantity_sect">
                                            <button onclick="buttonClick_Dec();">-</button>
                                            <input type="text" id="quantity" defaultValue={2} />
                                            <button onclick="buttonClick_Inc();">+</button>
                                        </div> */}
                    <div className="mint_quantity_sect">
                      <button onClick={decreaseQuantity}>-</button>
                      <input
                        type="text"
                        id="quantity"
                        value={quantity}
                        readOnly
                      />
                      <button onClick={increaseQuantity}>+</button>
                    </div>
                    <h5>
                      <span>{mintPrice}</span> BROCK
                    </h5>
                  </li>
                </ul>
              </div>
              {address ? (
                <button
                  className="modal_mint_btn hov_shape_show"
                  onClick={mintNFT}
                >
                  {spinner ? "Loading..." : "MINT NOW"}

                  <span className="hov_shape1">
                    <img src="assets/images/hov_shape_L_dark.svg" alt="" />
                  </span>
                  <span className="hov_shape2">
                    <img src="assets/images/hov_shape_L_dark.svg" alt="" />
                  </span>
                </button>
              ) : (
                <button
                  className="connect_btn hov_shape_show"
                  onClick={() =>
                    address
                      ? chain?.id == chains[0]?.id
                        ? (open(), props.onHide())
                        : switchNetwork?.(chains[0]?.id)
                      : (open(), props.onHide())
                  }
                >
                  <img src="assets/images/connect_wallet.svg" alt="" />
                  {address ? (
                    chain?.id == chains[0]?.id || chain?.id == chains[1]?.id ? (
                      address ? (
                        <>
                          {`${address?.substring(0, 6)}...${address?.substring(
                            address.length - 4
                          )}`}
                        </>
                      ) : (
                        <>CONNECT</>
                      )
                    ) : (
                      "Switch NetWork"
                    )
                  ) : (
                    <>CONNECT</>
                  )}

                  <span className="hov_shape1">
                    <img src="assets/images/hov_shape_s.svg" alt="" />
                  </span>
                  <span className="hov_shape2">
                    <img src="assets/images/hov_shape_s.svg" alt="" />
                  </span>
                  <span className="square_hov_shape" />
                </button>
              )}

              {/* <h6>Presale &amp; Whitelist : Soldout</h6> */}
            </div>
            <div className="modal_bottom_shape">
              <span className="modal_bottom_shape_left">
                <img src="assets/images/hov_shape_L.svg" alt="" />
              </span>
              <span className="modal_bottom_shape_right">
                <img src="assets/images/hov_shape_L.svg" alt="" />
              </span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
